import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ErrorResponseInterceptor } from './error-response-interceptor/error-response.interceptor';
import { LoadingInterceptor } from './loading-interceptor/loading.interceptor';

@NgModule({
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: ErrorResponseInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
    ]
})
export class InterceptorModule {
}
